import{isNullOrUndefined as r}from"./helpers.js";var n=function(n){return r(n)?null:Array.isArray(n)?n.map((function(r){return isNaN(Number(r))?r:r+"px"})).join(" "):isNaN(Number(n))?n:n+"px"};export{n as handlePx};
